import React, { useState } from 'react';
import BuildingTable from 'app/edozvola/cases/construction-building-procedure/buildings/building-table';
import BuildingForm from 'app/edozvola/cases/construction-building-procedure/buildings/building-form';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import '../construction-building-procedure.scss';
import { useFormik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import { copyBuildingsFromCaseQuery } from 'app/edozvola/cases/construction-building-procedure/service/construction-building-procedure.queries';
import { caseWebIdToCopyFromSchema } from '../construction-building-procedure.schema';
import { Col, Row } from 'reactstrap';
import { CASE_TAB_ENUM } from 'app/config/constants';
import BuildingFormV2 from 'app/edozvola/cases/construction-building-procedure/buildings/building-form-v2';
import {PaginatedDropdown} from "edozvola-frontend-lib/dist/ui/components/paginated-dropdown";
import { getCaseContext } from 'app/shared/util/context-util';

const Buildings = ({
  buildingNumberOptions,
  isBuildingNumberOptionsLoading,
  selectedBuildingNumberOption,
  setBuildingNumberOptions,
  formik,
  variant,
}) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idBuilding, setIdBuilding] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const copyBuildingsFormik = useFormik({
    initialValues: { caseWebIdToCopyFrom: '' },
    validationSchema: caseWebIdToCopyFromSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => copyBuildings(values.caseWebIdToCopyFrom),
  });

  const { mutate: copyBuildings, isPending: isCopyBuildingsPending } = copyBuildingsFromCaseQuery(
    uuid,
    variant,
    copyBuildingsFormik.resetForm,
  );

  const openBuildingForm = () => {
    setIdBuilding('');
    setReadOnly(false);
  };

  return (
    <>
      <h6 className="form-header mb-0">Zgrada</h6>
      <div className={'pt-4 pb-4'}>
        <Row>
          <Col md={5}>
            <Label labelText="Broj zgrada" />
            <PaginatedDropdown
              placeholder={!sidebarItemPair?.readOnly && 'Odaberi broj zgrada'}
              onItemSelect={setBuildingNumberOptions}
              selected={selectedBuildingNumberOption}
              labelKey={'value'}
              options={isBuildingNumberOptionsLoading ? [] : buildingNumberOptions}
              disabled={sidebarItemPair?.readOnly}
              error={!sidebarItemPair?.readOnly && (formik.errors.buildingNumber as string)}
              showErrorMessage
              clearButton
            />
          </Col>
        </Row>
      </div>
      {!sidebarItemPair?.readOnly && (
        <>
          <div className="d-flex justify-content-end pb-4 gap-2">
            <div className="case-copy-from-other-case">
              <Input
                placeholder="Unesite šifru predmeta"
                maxLength={255}
                addonAppend={
                  isCopyBuildingsPending ? (
                    <FontAwesomeIcon icon="spinner" spin />
                  ) : (
                    <FontAwesomeIcon
                      aria-disabled={
                        !!copyBuildingsFormik.errors?.caseWebIdToCopyFrom || copyBuildingsFormik.values.caseWebIdToCopyFrom === ''
                      }
                      className={
                        !!copyBuildingsFormik.errors?.caseWebIdToCopyFrom || copyBuildingsFormik.values.caseWebIdToCopyFrom === ''
                          ? 'disabled'
                          : ''
                      }
                      icon="copy"
                    />
                  )
                }
                value={copyBuildingsFormik.values.caseWebIdToCopyFrom}
                onChange={event => {
                  copyBuildingsFormik.setFieldValue('caseWebIdToCopyFrom', event.target.value);

                  if (copyBuildingsFormik.submitCount > 0) {
                    copyBuildingsFormik.setErrors({});
                  }
                }}
                addonAppendClick={() => {
                  if (!isCopyBuildingsPending) {
                    copyBuildingsFormik.handleSubmit();
                  }
                }}
                error={copyBuildingsFormik.errors?.caseWebIdToCopyFrom || ''}
              />
            </div>
            <div>
              <Button label="Dodaj zgradu" color="info" prependIcon="plus" size="lg" onClick={openBuildingForm} />
            </div>
          </div>
        </>
      )}

      <BuildingTable setIdBuilding={setIdBuilding} setReadOnly={setReadOnly} variant={variant} />
      {idBuilding !== null && (
        <>
          {variant === CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE && (
            <BuildingForm
              readOnly={readOnly}
              setIdBuilding={setIdBuilding}
              idBuilding={idBuilding}
              variant={CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE}
            />
          )}
          {variant === CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE_V2 && (
            <BuildingFormV2
              readOnly={readOnly}
              setIdBuilding={setIdBuilding}
              idBuilding={idBuilding}
              variant={CASE_TAB_ENUM.CONSTRUCTION_BUILDING_PROCEDURE_V2}
            />
          )}
        </>
      )}
    </>
  );
};

export default Buildings;
